import * as React from 'react';
import SectionMessage, { SectionMessageProps } from '@atlaskit/section-message';

export interface Props {
  appearance: SectionMessageProps['appearance'];
  title?: string;
  message: string;
  link?: {
    label: string;
    href: string;
  };
}

export default function Banner(props: Props) {
  const {
    appearance,
    title,
    message,
    link = {
      href: '',
      label: '',
    },
  } = props;

  const { href, label } = link;

  return (
    <div className="app-banner">
      <SectionMessage appearance={appearance}>
        <div className="banner-inline-text">
          {title && <strong>{title}</strong>}
          <span>{message}</span>
          {href && (
            <a href={href} target="_blank">
              {label}
            </a>
          )}
        </div>
      </SectionMessage>
    </div>
  );
}
